export const OUTBOUND_TICKET_IMAGE_TYPE = {
  MATERIAL_GROSS: 'material-gross',
  MATERIAL_TARE: 'material-tare',
  OUTBOUND_TICKET_GROSS: 'outbound-ticket-gross',
  OUTBOUND_TICKET_TARE: 'outbound-ticket-tare',
}
